export const tkDegDaysArray = [

{tk: 10000, value: 0.4321157160},
{tk: 10009, value: 0.4321157160},
{tk: 10010, value: 0.4321157160},
{tk: 10020, value: 0.4321157160},
{tk: 10021, value: 0.4321157160},
{tk: 10022, value: 0.4321157160},
{tk: 10023, value: 0.4321157160},
{tk: 10024, value: 0.4321157160},
{tk: 10025, value: 0.4321157160},
{tk: 10026, value: 0.4321157160},
{tk: 10027, value: 0.4321157160},
{tk: 10028, value: 0.4321157160},
{tk: 10029, value: 0.4321157160},
{tk: 10032, value: 0.4321157160},
{tk: 10033, value: 0.4321157160},
{tk: 10034, value: 0.4321157160},
{tk: 10035, value: 0.4321157160},
{tk: 10037, value: 0.4321157160},
{tk: 10038, value: 0.4321157160},
{tk: 10040, value: 0.4321157160},
{tk: 10100, value: 0.4321157160},
{tk: 10101, value: 0.4321157160},
{tk: 10102, value: 0.4321157160},
{tk: 10103, value: 0.4321157160},
{tk: 10104, value: 0.4321157160},
{tk: 10110, value: 0.4321157160},
{tk: 10160, value: 0.4321157160},
{tk: 10161, value: 0.4321157160},
{tk: 10162, value: 0.4321157160},
{tk: 10163, value: 0.4321157160},
{tk: 10164, value: 0.4321157160},
{tk: 10165, value: 0.4321157160},
{tk: 10166, value: 0.4321157160},
{tk: 10167, value: 0.4321157160},
{tk: 10168, value: 0.4321157160},
{tk: 10169, value: 0.4321157160},
{tk: 10170, value: 0.4321157160},
{tk: 10171, value: 0.4321157160},
{tk: 10172, value: 0.4321157160},
{tk: 10173, value: 0.4321157160},
{tk: 10174, value: 0.4321157160},
{tk: 10175, value: 0.4321157160},
{tk: 10176, value: 0.4321157160},
{tk: 10177, value: 0.4321157160},
{tk: 10178, value: 0.4321157160},
{tk: 10179, value: 0.4321157160},
{tk: 10180, value: 0.4321157160},
{tk: 10181, value: 0.4321157160},
{tk: 10182, value: 0.4321157160},
{tk: 10183, value: 0.4321157160},
{tk: 10184, value: 0.4321157160},
{tk: 10185, value: 0.4321157160},
{tk: 10186, value: 0.4321157160},
{tk: 10187, value: 0.4321157160},
{tk: 10188, value: 0.4321157160},
{tk: 10189, value: 0.4321157160},
{tk: 10190, value: 0.4321157160},
{tk: 10191, value: 0.4321157160},
{tk: 10192, value: 0.4321157160},
{tk: 10193, value: 0.4321157160},
{tk: 10200, value: 0.4321157160},
{tk: 10210, value: 0.4321157160},
{tk: 10220, value: 0.4321157160},
{tk: 10221, value: 0.4321157160},
{tk: 10222, value: 0.4321157160},
{tk: 10223, value: 0.4321157160},
{tk: 10225, value: 0.4321157160},
{tk: 10226, value: 0.4321157160},
{tk: 10227, value: 0.4321157160},
{tk: 10228, value: 0.4321157160},
{tk: 10229, value: 0.4321157160},
{tk: 10230, value: 0.4321157160},
{tk: 10231, value: 0.4321157160},
{tk: 10233, value: 0.4321157160},
{tk: 10235, value: 0.4321157160},
{tk: 10236, value: 0.4321157160},
{tk: 10237, value: 0.4321157160},
{tk: 10238, value: 0.4321157160},
{tk: 10239, value: 0.4321157160},
{tk: 10240, value: 0.4321157160},
{tk: 10241, value: 0.4321157160},
{tk: 10242, value: 0.4321157160},
{tk: 10244, value: 0.4321157160},
{tk: 10245, value: 0.4321157160},
{tk: 10246, value: 0.4321157160},
{tk: 10247, value: 0.4321157160},
{tk: 10248, value: 0.4321157160},
{tk: 10249, value: 0.4321157160},
{tk: 10250, value: 0.4321157160},
{tk: 10251, value: 0.4321157160},
{tk: 10252, value: 0.4321157160},
{tk: 10300, value: 0.4321157160},
{tk: 10310, value: 0.4321157160},
{tk: 10390, value: 0.4321157160},
{tk: 10391, value: 0.4321157160},
{tk: 10392, value: 0.4321157160},
{tk: 10393, value: 0.4321157160},
{tk: 10431, value: 0.4321157160},
{tk: 10432, value: 0.4321157160},
{tk: 10433, value: 0.4321157160},
{tk: 10434, value: 0.4321157160},
{tk: 10435, value: 0.4321157160},
{tk: 10436, value: 0.4321157160},
{tk: 10437, value: 0.4321157160},
{tk: 10438, value: 0.4321157160},
{tk: 10439, value: 0.4321157160},
{tk: 10440, value: 0.4321157160},
{tk: 10441, value: 0.4321157160},
{tk: 10442, value: 0.4321157160},
{tk: 10443, value: 0.4321157160},
{tk: 10444, value: 0.4321157160},
{tk: 10445, value: 0.4321157160},
{tk: 10446, value: 0.4321157160},
{tk: 10447, value: 0.4321157160},
{tk: 10448, value: 0.4321157160},
{tk: 10449, value: 0.4321157160},
{tk: 10533, value: 0.4321157160},
{tk: 10551, value: 0.4321157160},
{tk: 10552, value: 0.4321157160},
{tk: 10553, value: 0.4321157160},
{tk: 10554, value: 0.4321157160},
{tk: 10555, value: 0.4321157160},
{tk: 10556, value: 0.4321157160},
{tk: 10557, value: 0.4321157160},
{tk: 10558, value: 0.4321157160},
{tk: 10559, value: 0.4321157160},
{tk: 10560, value: 0.4321157160},
{tk: 10561, value: 0.4321157160},
{tk: 10562, value: 0.4321157160},
{tk: 10563, value: 0.4321157160},
{tk: 10564, value: 0.4321157160},
{tk: 10671, value: 0.4321157160},
{tk: 10672, value: 0.4321157160},
{tk: 10673, value: 0.4321157160},
{tk: 10674, value: 0.4321157160},
{tk: 10675, value: 0.4321157160},
{tk: 10676, value: 0.4321157160},
{tk: 10677, value: 0.4321157160},
{tk: 10678, value: 0.4321157160},
{tk: 10679, value: 0.4321157160},
{tk: 10680, value: 0.4321157160},
{tk: 10681, value: 0.4321157160},
{tk: 10682, value: 0.4321157160},
{tk: 10683, value: 0.4321157160},
{tk: 11100, value: 0.5334739180},
{tk: 11101, value: 0.4321157160},
{tk: 11102, value: 0.5334739180},
{tk: 11103, value: 0.5334739180},
{tk: 11110, value: 0.4321157160},
{tk: 11141, value: 0.4321157160},
{tk: 11142, value: 0.4321157160},
{tk: 11143, value: 0.4321157160},
{tk: 11144, value: 0.4321157160},
{tk: 11145, value: 0.4321157160},
{tk: 11146, value: 0.5334739180},
{tk: 11147, value: 0.5334739180},
{tk: 11201, value: 0.4321157160},
{tk: 11210, value: 0.4321157160},
{tk: 11251, value: 0.4321157160},
{tk: 11252, value: 0.4321157160},
{tk: 11253, value: 0.4321157160},
{tk: 11254, value: 0.4321157160},
{tk: 11255, value: 0.4321157160},
{tk: 11256, value: 0.4321157160},
{tk: 11257, value: 0.4321157160},
{tk: 11301, value: 0.4321157160},
{tk: 11310, value: 0.4321157160},
{tk: 11343, value: 0.4321157160},
{tk: 11361, value: 0.4321157160},
{tk: 11362, value: 0.4321157160},
{tk: 11363, value: 0.4321157160},
{tk: 11364, value: 0.4321157160},
{tk: 11401, value: 0.4321157160},
{tk: 11402, value: 0.4321157160},
{tk: 11403, value: 0.4321157160},
{tk: 11410, value: 0.4321157160},
{tk: 11471, value: 0.4321157160},
{tk: 11472, value: 0.4321157160},
{tk: 11473, value: 0.4321157160},
{tk: 11474, value: 0.4321157160},
{tk: 11475, value: 0.4321157160},
{tk: 11476, value: 0.4321157160},
{tk: 11501, value: 0.4321157160},
{tk: 11502, value: 0.4321157160},
{tk: 11503, value: 0.4321157160},
{tk: 11510, value: 0.4321157160},
{tk: 11521, value: 0.4321157160},
{tk: 11522, value: 0.4321157160},
{tk: 11523, value: 0.4321157160},
{tk: 11524, value: 0.4321157160},
{tk: 11525, value: 0.5221400960},
{tk: 11526, value: 0.4321157160},
{tk: 11527, value: 0.4321157160},
{tk: 11528, value: 0.4321157160},
{tk: 11601, value: 0.4321157160},
{tk: 11602, value: 0.4321157160},
{tk: 11603, value: 0.4321157160},
{tk: 11610, value: 0.4321157160},
{tk: 11631, value: 0.4321157160},
{tk: 11632, value: 0.4321157160},
{tk: 11633, value: 0.4321157160},
{tk: 11634, value: 0.4321157160},
{tk: 11635, value: 0.4321157160},
{tk: 11636, value: 0.4321157160},
{tk: 11680, value: 0.4321157160},
{tk: 11701, value: 0.4321157160},
{tk: 11702, value: 0.4321157160},
{tk: 11703, value: 0.4321157160},
{tk: 11704, value: 0.4321157160},
{tk: 11710, value: 0.4321157160},
{tk: 11741, value: 0.4321157160},
{tk: 11742, value: 0.4321157160},
{tk: 11743, value: 0.4321157160},
{tk: 11744, value: 0.4321157160},
{tk: 11745, value: 0.4321157160},
{tk: 11780, value: 0.4321157160},
{tk: 11782, value: 0.4321157160},
{tk: 11801, value: 0.4321157160},
{tk: 11810, value: 0.4321157160},
{tk: 11851, value: 0.4321157160},
{tk: 11852, value: 0.4321157160},
{tk: 11853, value: 0.4321157160},
{tk: 11854, value: 0.4321157160},
{tk: 11855, value: 0.4321157160},
{tk: 12000, value: 0.4345248410},
{tk: 12010, value: 0.4345248410},
{tk: 12100, value: 0.4345248410},
{tk: 12101, value: 0.4345248410},
{tk: 12102, value: 0.4345248410},
{tk: 12103, value: 0.4345248410},
{tk: 12104, value: 0.4345248410},
{tk: 12105, value: 0.4345248410},
{tk: 12106, value: 0.4345248410},
{tk: 12110, value: 0.4345248410},
{tk: 12131, value: 0.4345248410},
{tk: 12132, value: 0.4345248410},
{tk: 12133, value: 0.4345248410},
{tk: 12134, value: 0.4345248410},
{tk: 12135, value: 0.4345248410},
{tk: 12136, value: 0.4345248410},
{tk: 12137, value: 0.4345248410},
{tk: 12200, value: 0.4006340200},
{tk: 12201, value: 0.4006340200},
{tk: 12210, value: 0.4006340200},
{tk: 12241, value: 0.4006340200},
{tk: 12242, value: 0.4006340200},
{tk: 12243, value: 0.4006340200},
{tk: 12244, value: 0.4006340200},
{tk: 12300, value: 0.4170244680},
{tk: 12301, value: 0.4170244680},
{tk: 12310, value: 0.4170244680},
{tk: 12351, value: 0.4170244680},
{tk: 12400, value: 0.4857224190},
{tk: 12401, value: 0.4857224190},
{tk: 12402, value: 0.4857224190},
{tk: 12410, value: 0.4857224190},
{tk: 12461, value: 0.3817234970},
{tk: 12462, value: 0.4857224190},
{tk: 13100, value: 0.4658330960},
{tk: 13101, value: 0.4658330960},
{tk: 13102, value: 0.4658330960},
{tk: 13110, value: 0.4658330960},
{tk: 13121, value: 0.4658330960},
{tk: 13122, value: 0.4658330960},
{tk: 13123, value: 0.4658330960},
{tk: 13200, value: 0.4980778330},
{tk: 13201, value: 0.4980778330},
{tk: 13210, value: 0.4980778330},
{tk: 13223, value: 0.4658330960},
{tk: 13231, value: 0.4980778330},
{tk: 13232, value: 0.4980778330},
{tk: 13300, value: 0.5265113320},
{tk: 13301, value: 0.5265113320},
{tk: 13310, value: 0.5265113320},
{tk: 13341, value: 0.5265113320},
{tk: 13342, value: 0.5265113320},
{tk: 13343, value: 0.5265113320},
{tk: 13344, value: 0.5265113320},
{tk: 13345, value: 0.5265113320},
{tk: 13351, value: 0.6880050660},
{tk: 13352, value: 0.5119440380},
{tk: 13400, value: 0.5244975450},
{tk: 13401, value: 0.5244975450},
{tk: 13402, value: 0.5119440380},
{tk: 13410, value: 0.5244975450},
{tk: 13451, value: 0.5244975450},
{tk: 13461, value: 0.5119440380},
{tk: 13471, value: 0.5119440380},
{tk: 13500, value: 0.4568805610},
{tk: 13501, value: 0.4568805610},
{tk: 13510, value: 0.4568805610},
{tk: 13561, value: 0.4568805610},
{tk: 13562, value: 0.4568805610},
{tk: 13600, value: 0.5339253400},
{tk: 13601, value: 0.5339253400},
{tk: 13602, value: 0.5339253400},
{tk: 13603, value: 0.6623340520},
{tk: 13610, value: 0.5339253400},
{tk: 13640, value: 0.6623340520},
{tk: 13671, value: 0.5339253400},
{tk: 13672, value: 0.5339253400},
{tk: 13673, value: 0.5339253400},
{tk: 13674, value: 0.5339253400},
{tk: 13675, value: 0.5339253400},
{tk: 13676, value: 0.6623340520},
{tk: 13677, value: 0.6196156820},
{tk: 13678, value: 0.5339253400},
{tk: 13679, value: 0.9449753150},
{tk: 14100, value: 0.5185122680},
{tk: 14101, value: 0.5185122680},
{tk: 14102, value: 0.5668880890},
{tk: 14110, value: 0.5185122680},
{tk: 14121, value: 0.5185122680},
{tk: 14122, value: 0.5185122680},
{tk: 14123, value: 0.5668880890},
{tk: 14200, value: 0.5032187570},
{tk: 14201, value: 0.5032187570},
{tk: 14202, value: 0.5032187570},
{tk: 14203, value: 0.5032187570},
{tk: 14210, value: 0.5032187570},
{tk: 14231, value: 0.5032187570},
{tk: 14232, value: 0.5032187570},
{tk: 14233, value: 0.5032187570},
{tk: 14234, value: 0.5032187570},
{tk: 14235, value: 0.5032187570},
{tk: 14300, value: 0.4758820600},
{tk: 14301, value: 0.4758820600},
{tk: 14302, value: 0.4758820600},
{tk: 14310, value: 0.4758820600},
{tk: 14341, value: 0.4758820600},
{tk: 14342, value: 0.4758820600},
{tk: 14343, value: 0.4691533575},
{tk: 14400, value: 0.5274743990},
{tk: 14401, value: 0.5274743990},
{tk: 14410, value: 0.5274743990},
{tk: 14451, value: 0.5274743990},
{tk: 14452, value: 0.5274743990},
{tk: 14500, value: 0.6134509280},
{tk: 14501, value: 0.6134509280},
{tk: 14502, value: 0.6684861920},
{tk: 14503, value: 0.6134509280},
{tk: 14504, value: 0.6789520260},
{tk: 14510, value: 0.6134509280},
{tk: 14550, value: 0.6684861920},
{tk: 14561, value: 0.6134509280},
{tk: 14562, value: 0.6134509280},
{tk: 14563, value: 0.6134509280},
{tk: 14564, value: 0.6134509280},
{tk: 14565, value: 0.6649182125},
{tk: 14566, value: 0.6196156820},
{tk: 14567, value: 0.6684861920},
{tk: 14568, value: 0.6714234750},
{tk: 14569, value: 0.6699392360},
{tk: 14572, value: 0.6789520260},
{tk: 14574, value: 0.6970062930},
{tk: 14575, value: 0.6886233860},
{tk: 14576, value: 0.7410612207},
{tk: 14578, value: 0.6665837270},
{tk: 14600, value: 0.6285029430},
{tk: 14601, value: 0.6285029430},
{tk: 14610, value: 0.6285029430},
{tk: 14671, value: 0.6285029430},
{tk: 14678, value: 0.6665837270},
{tk: 15100, value: 0.5740705020},
{tk: 15101, value: 0.5740705020},
{tk: 15102, value: 0.6144326440},
{tk: 15103, value: 0.5822728140},
{tk: 15104, value: 0.5740705020},
{tk: 15105, value: 0.5740705020},
{tk: 15106, value: 0.5740705020},
{tk: 15110, value: 0.5740705020},
{tk: 15121, value: 0.5822728140},
{tk: 15122, value: 0.5740705020},
{tk: 15123, value: 0.5740705020},
{tk: 15124, value: 0.5740705020},
{tk: 15125, value: 0.5740705020},
{tk: 15126, value: 0.5740705020},
{tk: 15127, value: 0.6144326440},
{tk: 15180, value: 0.5740705020},
{tk: 15200, value: 0.5300749720},
{tk: 15201, value: 0.5300749720},
{tk: 15203, value: 0.5663128320},
{tk: 15204, value: 0.6862540690},
{tk: 15210, value: 0.5300749720},
{tk: 15223, value: 0.5740705020},
{tk: 15231, value: 0.5300749720},
{tk: 15232, value: 0.5300749720},
{tk: 15233, value: 0.5300749720},
{tk: 15234, value: 0.5300749720},
{tk: 15235, value: 0.5663128320},
{tk: 15236, value: 0.6447461955},
{tk: 15237, value: 0.5213573880},
{tk: 15238, value: 0.5300749720},
{tk: 15239, value: 0.6826937530},
{tk: 15250, value: 0.5663128320},
{tk: 15255, value: 0.5300749720},
{tk: 15300, value: 0.5738983830},
{tk: 15301, value: 0.5738983830},
{tk: 15302, value: 0.5486127050},
{tk: 15304, value: 0.5716135660},
{tk: 15306, value: 0.5584005400},
{tk: 15310, value: 0.5738983830},
{tk: 15341, value: 0.5738983830},
{tk: 15342, value: 0.5738983830},
{tk: 15343, value: 0.5738983830},
{tk: 15344, value: 0.5584005400},
{tk: 15345, value: 0.5738983830},
{tk: 15349, value: 0.6238943140},
{tk: 15351, value: 0.5509237165},
{tk: 15353, value: 0.5738983830},
{tk: 15354, value: 0.5716135660},
{tk: 15360, value: 0.5584005400},
{tk: 15362, value: 0.5716135660},
{tk: 15400, value: 0.5359377710},
{tk: 15401, value: 0.5359377710},
{tk: 15402, value: 0.5359377710},
{tk: 15410, value: 0.5359377710},
{tk: 15451, value: 0.5359377710},
{tk: 15452, value: 0.5359377710},
{tk: 15500, value: 0.5370228070},
{tk: 15501, value: 0.5370228070},
{tk: 15510, value: 0.5370228070},
{tk: 15561, value: 0.5370228070},
{tk: 15562, value: 0.5370228070},
{tk: 15600, value: 0.5446177840},
{tk: 15601, value: 0.5446177840},
{tk: 15610, value: 0.5446177840},
{tk: 15669, value: 0.5446177840},
{tk: 15700, value: 0.4935747610},
{tk: 15701, value: 0.4935747610},
{tk: 15702, value: 0.4935747610},
{tk: 15703, value: 0.4935747610},
{tk: 15704, value: 0.4935747610},
{tk: 15710, value: 0.4935747610},
{tk: 15771, value: 0.4935747610},
{tk: 15772, value: 0.4935747610},
{tk: 15773, value: 0.4935747610},
{tk: 15780, value: 0.4935747610},
{tk: 15781, value: 0.4935747610},
{tk: 15782, value: 0.4935747610},
{tk: 15783, value: 0.4935747610},
{tk: 15784, value: 0.4935747610},
{tk: 15785, value: 0.4935747610},
{tk: 15786, value: 0.4935747610},
{tk: 16000, value: 0.4831636900},
{tk: 16010, value: 0.4831636900},
{tk: 16100, value: 0.4831636900},
{tk: 16101, value: 0.4831636900},
{tk: 16102, value: 0.4831636900},
{tk: 16110, value: 0.4831636900},
{tk: 16121, value: 0.4831636900},
{tk: 16122, value: 0.5424353710},
{tk: 16141, value: 0.4321157160},
{tk: 16200, value: 0.4678544110},
{tk: 16201, value: 0.4678544110},
{tk: 16202, value: 0.4678544110},
{tk: 16210, value: 0.4678544110},
{tk: 16231, value: 0.4678544110},
{tk: 16232, value: 0.4678544110},
{tk: 16233, value: 0.4678544110},
{tk: 16300, value: 0.4721248710},
{tk: 16301, value: 0.4721248710},
{tk: 16310, value: 0.4721248710},
{tk: 16341, value: 0.4721248710},
{tk: 16342, value: 0.4721248710},
{tk: 16343, value: 0.4721248710},
{tk: 16344, value: 0.4721248710},
{tk: 16345, value: 0.4721248710},
{tk: 16346, value: 0.4721248710},
{tk: 16400, value: 0.3865631100},
{tk: 16401, value: 0.3865631100},
{tk: 16410, value: 0.3865631100},
{tk: 16451, value: 0.3865631100},
{tk: 16452, value: 0.3865631100},
{tk: 16501, value: 0.3257731120},
{tk: 16510, value: 0.3257731120},
{tk: 16531, value: 0.3257731120},
{tk: 16561, value: 0.3257731120},
{tk: 16562, value: 0.3257731120},
{tk: 16574, value: 0.3257731120},
{tk: 16600, value: 0.3257731120},
{tk: 16601, value: 0.3257731120},
{tk: 16602, value: 0.3458427600},
{tk: 16603, value: 0.3295741100},
{tk: 16604, value: 0.3295741100},
{tk: 16605, value: 0.3255955340},
{tk: 16607, value: 0.3257731120},
{tk: 16608, value: 0.3136405100},
{tk: 16610, value: 0.3257731120},
{tk: 16671, value: 0.3136405100},
{tk: 16672, value: 0.3458427600},
{tk: 16673, value: 0.3255955340},
{tk: 16674, value: 0.3257731120},
{tk: 16675, value: 0.3257731120},
{tk: 16700, value: 0.3295741100},
{tk: 16701, value: 0.3295741100},
{tk: 16710, value: 0.3295741100},
{tk: 16772, value: 0.3458427600},
{tk: 16777, value: 0.3295741100},
{tk: 16872, value: 0.3458427600},
{tk: 16972, value: 0.3458427600},
{tk: 17100, value: 0.3840889820},
{tk: 17101, value: 0.3840889820},
{tk: 17102, value: 0.3840889820},
{tk: 17110, value: 0.3840889820},
{tk: 17121, value: 0.3840889820},
{tk: 17122, value: 0.3840889820},
{tk: 17123, value: 0.3840889820},
{tk: 17124, value: 0.3840889820},
{tk: 17200, value: 0.4133770750},
{tk: 17201, value: 0.4133770750},
{tk: 17202, value: 0.4418703550},
{tk: 17210, value: 0.4133770750},
{tk: 17234, value: 0.4133770750},
{tk: 17235, value: 0.4133770750},
{tk: 17236, value: 0.4418703550},
{tk: 17237, value: 0.4418703550},
{tk: 17242, value: 0.4030232410},
{tk: 17248, value: 0.4418703550},
{tk: 17249, value: 0.4133770750},
{tk: 17251, value: 0.4030232410},
{tk: 17300, value: 0.4030232410},
{tk: 17301, value: 0.4030232410},
{tk: 17310, value: 0.4030232410},
{tk: 17341, value: 0.4030232410},
{tk: 17342, value: 0.4030232410},
{tk: 17343, value: 0.4030232410},
{tk: 17455, value: 0.3291388620},
{tk: 17500, value: 0.3343351240},
{tk: 17501, value: 0.3343351240},
{tk: 17502, value: 0.3343351240},
{tk: 17503, value: 0.3343351240},
{tk: 17510, value: 0.3343351240},
{tk: 17561, value: 0.3343351240},
{tk: 17562, value: 0.3343351240},
{tk: 17563, value: 0.3343351240},
{tk: 17564, value: 0.3343351240},
{tk: 17600, value: 0.3698590090},
{tk: 17601, value: 0.3698590090},
{tk: 17602, value: 0.3698590090},
{tk: 17603, value: 0.3698590090},
{tk: 17605, value: 0.3698590090},
{tk: 17610, value: 0.3698590090},
{tk: 17661, value: 0.3698590090},
{tk: 17671, value: 0.3698590090},
{tk: 17672, value: 0.3698590090},
{tk: 17673, value: 0.3698590090},
{tk: 17674, value: 0.3698590090},
{tk: 17675, value: 0.3698590090},
{tk: 17676, value: 0.3698590090},
{tk: 17680, value: 0.3698590090},
{tk: 17700, value: 0.3785071820},
{tk: 17701, value: 0.3785071820},
{tk: 17710, value: 0.3785071820},
{tk: 17758, value: 0.3785071820},
{tk: 17778, value: 0.3785071820},
{tk: 18010, value: 0.3382311314},
{tk: 18011, value: 0.2890372607},
{tk: 18020, value: 0.4272186430},
{tk: 18030, value: 0.3908662636},
{tk: 18040, value: 0.3013476282},
{tk: 18050, value: 0.2552058242},
{tk: 18100, value: 0.3811169430},
{tk: 18101, value: 0.3811169430},
{tk: 18102, value: 0.3811169430},
{tk: 18110, value: 0.3811169430},
{tk: 18120, value: 0.3811169430},
{tk: 18121, value: 0.3811169430},
{tk: 18122, value: 0.3811169430},
{tk: 18200, value: 0.3614042490},
{tk: 18201, value: 0.3614042490},
{tk: 18202, value: 0.3614042490},
{tk: 18210, value: 0.3614042490},
{tk: 18233, value: 0.3614042490},
{tk: 18300, value: 0.3429652240},
{tk: 18301, value: 0.3429652240},
{tk: 18310, value: 0.3429652240},
{tk: 18344, value: 0.3429652240},
{tk: 18345, value: 0.3429652240},
{tk: 18346, value: 0.3429652240},
{tk: 18400, value: 0.3702610270},
{tk: 18401, value: 0.3702610270},
{tk: 18402, value: 0.3702610270},
{tk: 18410, value: 0.3702610270},
{tk: 18450, value: 0.3702610270},
{tk: 18451, value: 0.3702610270},
{tk: 18452, value: 0.3702610270},
{tk: 18453, value: 0.3702610270},
{tk: 18454, value: 0.3702610270},
{tk: 18500, value: 0.3321809220},
{tk: 18501, value: 0.3321809220},
{tk: 18502, value: 0.3321809220},
{tk: 18503, value: 0.3321809220},
{tk: 18504, value: 0.3321809220},
{tk: 18505, value: 0.3321809220},
{tk: 18506, value: 0.3321809220},
{tk: 18507, value: 0.3321809220},
{tk: 18508, value: 0.3321809220},
{tk: 18509, value: 0.3321809220},
{tk: 18510, value: 0.3321809220},
{tk: 18511, value: 0.3614042490},
{tk: 18512, value: 0.3321809220},
{tk: 18516, value: 0.3321809220},
{tk: 18517, value: 0.3321809220},
{tk: 18518, value: 0.3321809220},
{tk: 18519, value: 0.3321809220},
{tk: 18520, value: 0.3321809220},
{tk: 18521, value: 0.3321809220},
{tk: 18522, value: 0.3321809220},
{tk: 18523, value: 0.3321809220},
{tk: 18524, value: 0.3321809220},
{tk: 18531, value: 0.3321809220},
{tk: 18532, value: 0.3321809220},
{tk: 18533, value: 0.3321809220},
{tk: 18534, value: 0.3321809220},
{tk: 18535, value: 0.3321809220},
{tk: 18536, value: 0.3321809220},
{tk: 18537, value: 0.3321809220},
{tk: 18538, value: 0.3321809220},
{tk: 18539, value: 0.3321809220},
{tk: 18540, value: 0.3321809220},
{tk: 18541, value: 0.3321809220},
{tk: 18542, value: 0.3321809220},
{tk: 18543, value: 0.3321809220},
{tk: 18544, value: 0.3321809220},
{tk: 18545, value: 0.3321809220},
{tk: 18546, value: 0.3321809220},
{tk: 18547, value: 0.3321809220},
{tk: 18600, value: 0.3321809220},
{tk: 18601, value: 0.3321809220},
{tk: 18610, value: 0.3321809220},
{tk: 18648, value: 0.3237367420},
{tk: 18700, value: 0.3693279010},
{tk: 18701, value: 0.3693279010},
{tk: 18702, value: 0.3693279010},
{tk: 18710, value: 0.3693279010},
{tk: 18755, value: 0.3693279010},
{tk: 18756, value: 0.3693279010},
{tk: 18757, value: 0.3693279010},
{tk: 18758, value: 0.3693279010},
{tk: 18800, value: 0.3469741820},
{tk: 18801, value: 0.3469741820},
{tk: 18810, value: 0.3469741820},
{tk: 18863, value: 0.3592440115},
{tk: 18870, value: 0.3579482010},
{tk: 18900, value: 0.3774769180},
{tk: 18904, value: 0.3579482010},
{tk: 18910, value: 0.3579482010},
{tk: 18950, value: 0.3125505480},
{tk: 19001, value: 0.4383125722},
{tk: 19002, value: 0.5354812280},
{tk: 19003, value: 0.4044833712},
{tk: 19004, value: 0.4848360373},
{tk: 19005, value: 0.4679285460},
{tk: 19006, value: 0.4022085740},
{tk: 19007, value: 0.4877372140},
{tk: 19008, value: 0.7005155440},
{tk: 19009, value: 0.5026352946},
{tk: 19010, value: 0.4681605700},
{tk: 19011, value: 0.5778544174},
{tk: 19012, value: 0.6179173308},
{tk: 19013, value: 0.3444728392},
{tk: 19014, value: 0.6384618920},
{tk: 19015, value: 0.4330694783},
{tk: 19016, value: 0.3862864180},
{tk: 19018, value: 0.4664520435},
{tk: 19020, value: 0.4681605700},
{tk: 19023, value: 0.3866535610},
{tk: 19029, value: 0.3843736780},
{tk: 19100, value: 0.4369800934},
{tk: 19200, value: 0.4105803090},
{tk: 19201, value: 0.4105803090},
{tk: 19300, value: 0.4226402450},
{tk: 19301, value: 0.4226402450},
{tk: 19400, value: 0.4946626790},
{tk: 19401, value: 0.4946626790},
{tk: 19402, value: 0.4532522240},
{tk: 19403, value: 0.4681605700},
{tk: 19410, value: 0.4946626790},
{tk: 19441, value: 0.4929148695},
{tk: 19442, value: 0.4183673430},
{tk: 19443, value: 0.3657730445},
{tk: 19500, value: 0.3528205548},
{tk: 19600, value: 0.6402305489},
{tk: 19601, value: 0.4910376650},
{tk: 19610, value: 0.4602869330},
{tk: 19701, value: 0.3902707250},
{tk: 19702, value: 0.3862864180},
{tk: 20003, value: 0.3500478450},
{tk: 20004, value: 0.5277315096},
{tk: 20006, value: 0.4760829627},
{tk: 20008, value: 0.6214961135},
{tk: 20009, value: 0.6148291934},
{tk: 20011, value: 0.383499315},
{tk: 20014, value: 0.9892385978},
{tk: 20100, value: 0.3707872180},
{tk: 20101, value: 0.3707872180},
{tk: 20110, value: 0.3707872180},
{tk: 20131, value: 0.3695940825},
{tk: 20132, value: 0.3722225615},
{tk: 20150, value: 0.4334629302},
{tk: 20200, value: 0.7676963608},
{tk: 20300, value: 0.4327064063},
{tk: 20400, value: 0.7238349959},
{tk: 20500, value: 0.8205577847},
{tk: 21051, value: 0.3524904572},
{tk: 21052, value: 0.5757394027},
{tk: 21055, value: 0.4475087087},
{tk: 21056, value: 0.3348962687},
{tk: 21059, value: 0.5158038019},
{tk: 21100, value: 0.3744333507},
{tk: 21200, value: 0.4225854490},
{tk: 21201, value: 0.4225854490},
{tk: 21210, value: 0.4225854490},
{tk: 21231, value: 0.4225854490},
{tk: 21232, value: 0.4225854490},
{tk: 21250, value: 0.6091548761},
{tk: 21300, value: 0.3281534128},
{tk: 22001, value: 0.6226263206},
{tk: 22002, value: 0.8904186497},
{tk: 22007, value: 0.7193291604},
{tk: 22008, value: 0.6314091201},
{tk: 22010, value: 0.9538572863},
{tk: 22012, value: 0.8694329482},
{tk: 22015, value: 0.8387255313},
{tk: 22027, value: 0.8085510539},
{tk: 22029, value: 0.5043202959},
{tk: 22132, value: 0.8478013100},
{tk: 22150, value: 0.9147945465},
{tk: 22200, value: 0.7443341057},
{tk: 22300, value: 0.8020552265},
{tk: 23051, value: 0.4972472368},
{tk: 23052, value: 0.4836287350},
{tk: 23053, value: 0.3378611537},
{tk: 23062, value: 0.4052906256},
{tk: 23066, value: 0.3279985220},
{tk: 23070, value: 0.4139979357},
{tk: 23100, value: 0.5763720365},
{tk: 23101, value: 0.5606709120},
{tk: 23110, value: 0.5606709120},
{tk: 23150, value: 0.7280102467},
{tk: 23200, value: 0.5117192790},
{tk: 24001, value: 0.5065216088},
{tk: 24002, value: 0.5160849083},
{tk: 24004, value: 0.4186684815},
{tk: 24005, value: 0.5704738073},
{tk: 24006, value: 0.3321660184},
{tk: 24008, value: 0.5732730679},
{tk: 24009, value: 0.5067110177},
{tk: 24011, value: 0.5983042106},
{tk: 24022, value: 0.4752733974},
{tk: 24100, value: 0.2829908580},
{tk: 24101, value: 0.2829908580},
{tk: 24102, value: 0.2829908580},
{tk: 24103, value: 0.2829908580},
{tk: 24110, value: 0.2829908580},
{tk: 24131, value: 0.2829908580},
{tk: 24132, value: 0.2741246030},
{tk: 24133, value: 0.3030049358},
{tk: 24134, value: 0.3075573050},
{tk: 24150, value: 0.5377364782},
{tk: 24200, value: 0.5460014999},
{tk: 24300, value: 0.3291336387},
{tk: 24400, value: 0.3740660508},
{tk: 24500, value: 0.4790084067},
{tk: 25001, value: 0.9789290650},
{tk: 25002, value: 0.3751688378},
{tk: 25003, value: 0.5930455735},
{tk: 25004, value: 0.9452033791},
{tk: 25006, value: 0.7695551615},
{tk: 25007, value: 0.8875295990},
{tk: 25008, value: 0.6809200576},
{tk: 25015, value: 0.6221054459},
{tk: 25100, value: 0.6791984217},
{tk: 25200, value: 0.4601549811},
{tk: 26000, value: 0.3000669690},
{tk: 26001, value: 0.3000669690},
{tk: 26002, value: 0.3000669690},
{tk: 26003, value: 0.3000669690},
{tk: 26004, value: 0.3000669690},
{tk: 26006, value: 0.3000669690},
{tk: 26007, value: 0.3000669690},
{tk: 26110, value: 0.3000669690},
{tk: 26221, value: 0.3000669690},
{tk: 26222, value: 0.3000669690},
{tk: 26223, value: 0.3000669690},
{tk: 26224, value: 0.3000669690},
{tk: 26225, value: 0.3000669690},
{tk: 26226, value: 0.3000669690},
{tk: 26232, value: 0.3000669690},
{tk: 26331, value: 0.3000669690},
{tk: 26332, value: 0.3406515840},
{tk: 26333, value: 0.3000669690},
{tk: 26334, value: 0.3000669690},
{tk: 26335, value: 0.4259459770},
{tk: 26336, value: 0.3000669690},
{tk: 26441, value: 0.3000669690},
{tk: 26442, value: 0.3000669690},
{tk: 26443, value: 0.4017429610},
{tk: 26444, value: 0.3000669690},
{tk: 26500, value: 0.5886462057},
{tk: 26502, value: 0.3000669690},
{tk: 26503, value: 0.3000669690},
{tk: 26517, value: 0.3000669690},
{tk: 27050, value: 0.3612226967},
{tk: 27051, value: 0.3981139120},
{tk: 27052, value: 0.4425864046},
{tk: 27053, value: 0.3809505724},
{tk: 27054, value: 0.4404303932},
{tk: 27055, value: 0.4404038962},
{tk: 27056, value: 0.6086640735},
{tk: 27061, value: 0.7253671901},
{tk: 27063, value: 0.8953204095},
{tk: 27064, value: 0.5401039781},
{tk: 27065, value: 0.4735869888},
{tk: 27066, value: 0.7517310757},
{tk: 27067, value: 0.3123726264},
{tk: 27069, value: 0.5205584725},
{tk: 27100, value: 0.3837461010},
{tk: 27101, value: 0.3837461010},
{tk: 27110, value: 0.3837461010},
{tk: 27131, value: 0.3873361074},
{tk: 27150, value: 0.3995665148},
{tk: 27200, value: 0.4235391632},
{tk: 27300, value: 0.4122903687},
{tk: 28080, value: 0.5267071494},
{tk: 28081, value: 0.5042924083},
{tk: 28084, value: 0.4272447409},
{tk: 28086, value: 0.4705423690},
{tk: 28100, value: 0.4326123655},
{tk: 28200, value: 0.3688410231},
{tk: 28300, value: 0.3699137908},
{tk: 28301, value: 0.3784246150},
{tk: 29090, value: 0.4323901986},
{tk: 29092, value: 0.4631235352},
{tk: 29100, value: 0.3562916709},
{tk: 30001, value: 0.4310863440},
{tk: 30002, value: 0.4638938201},
{tk: 30003, value: 0.4722296140},
{tk: 30004, value: 0.7077303568},
{tk: 30005, value: 0.4772949900},
{tk: 30006, value: 0.5571660360},
{tk: 30008, value: 0.8156253844},
{tk: 30009, value: 0.6131625834},
{tk: 30010, value: 0.6579258676},
{tk: 30011, value: 0.5943440847},
{tk: 30012, value: 0.4336565441},
{tk: 30014, value: 0.5479226413},
{tk: 30015, value: 0.6066103222},
{tk: 30017, value: 0.7657224320},
{tk: 30019, value: 0.5391563770},
{tk: 30020, value: 0.4293786932},
{tk: 30021, value: 0.8202748487},
{tk: 30022, value: 0.9940539210},
{tk: 30023, value: 0.9941328795},
{tk: 30027, value: 0.5148732160},
{tk: 30100, value: 0.5172859360},
{tk: 30110, value: 0.5172859360},
{tk: 30131, value: 0.5172859360},
{tk: 30132, value: 0.5172859360},
{tk: 30133, value: 0.5172859360},
{tk: 30150, value: 0.6299843397},
{tk: 30200, value: 0.4962596117},
{tk: 30300, value: 0.7716643860},
{tk: 30400, value: 0.4483569691},
{tk: 30500, value: 0.5561629385},
{tk: 31082, value: 0.5682322474},
{tk: 31084, value: 0.3992791747},
{tk: 31100, value: 0.5449895651},
{tk: 32001, value: 0.6311507524},
{tk: 32003, value: 0.4617812974},
{tk: 32004, value: 1.0298894810},
{tk: 32005, value: 0.8155919050},
{tk: 32006, value: 0.5697010906},
{tk: 32009, value: 0.6473085191},
{tk: 32100, value: 0.6601068120},
{tk: 32110, value: 0.6601068120},
{tk: 32131, value: 0.6601068120},
{tk: 32150, value: 0.6911055717},
{tk: 32200, value: 0.6083200988},
{tk: 32300, value: 0.5910804676},
{tk: 33052, value: 0.4422490780},
{tk: 33053, value: 1.0015628052},
{tk: 33054, value: 0.8958723076},
{tk: 33056, value: 0.8186248674},
{tk: 33057, value: 0.9963063186},
{tk: 33058, value: 0.5525956996},
{tk: 33100, value: 0.8418452126},
{tk: 33200, value: 0.4860920828},
{tk: 34001, value: 0.5144717180},
{tk: 34002, value: 0.4322481280},
{tk: 34003, value: 0.5989598385},
{tk: 34004, value: 0.5949346225},
{tk: 34005, value: 0.6680637141},
{tk: 34006, value: 0.5652066211},
{tk: 34007, value: 0.4455175264},
{tk: 34008, value: 0.4761664351},
{tk: 34009, value: 0.5413042520},
{tk: 34013, value: 0.4601314901},
{tk: 34015, value: 0.4252474858},
{tk: 34100, value: 0.4442359420},
{tk: 34110, value: 0.4442359420},
{tk: 34131, value: 0.4544935100},
{tk: 34132, value: 0.4442359420},
{tk: 34133, value: 0.4442359420},
{tk: 34150, value: 0.4939602721},
{tk: 34200, value: 0.6101220173},
{tk: 34300, value: 0.5420268328},
{tk: 34400, value: 0.5820162572},
{tk: 34500, value: 0.5173980534},
{tk: 34600, value: 0.6495928648},
{tk: 35001, value: 0.5117715114},
{tk: 35002, value: 0.9259717611},
{tk: 35003, value: 0.8950262203},
{tk: 35005, value: 0.6006895053},
{tk: 35006, value: 0.5234635245},
{tk: 35008, value: 0.6838034060},
{tk: 35009, value: 0.6377923605},
{tk: 35010, value: 0.8200660197},
{tk: 35011, value: 0.9064629909},
{tk: 35015, value: 0.7459741573},
{tk: 35100, value: 0.6320350480},
{tk: 35101, value: 0.6320350480},
{tk: 35102, value: 0.6320350480},
{tk: 35110, value: 0.6320350480},
{tk: 35131, value: 0.6320350480},
{tk: 35132, value: 0.6320350480},
{tk: 35133, value: 0.6320350480},
{tk: 35150, value: 0.7672932643},
{tk: 35200, value: 0.6307644067},
{tk: 35300, value: 0.6029972367},
{tk: 36071, value: 1.0304630316},
{tk: 36072, value: 0.8490548755},
{tk: 36080, value: 1.0516877023},
{tk: 36100, value: 1.0432275738},
{tk: 37001, value: 0.7906098356},
{tk: 37002, value: 0.4904544916},
{tk: 37003, value: 0.5053040629},
{tk: 37005, value: 0.4921445839},
{tk: 37006, value: 0.5688359086},
{tk: 37100, value: 0.6936627797},
{tk: 37300, value: 0.6699920955},
{tk: 37400, value: 0.5888469780},
{tk: 37500, value: 0.7292530071},
{tk: 38000, value: 0.5651519440},
{tk: 38001, value: 0.5651519440},
{tk: 38002, value: 0.5651519440},
{tk: 38003, value: 0.5651519440},
{tk: 38110, value: 0.5651519440},
{tk: 38221, value: 0.5651519440},
{tk: 38222, value: 0.5696960280},
{tk: 38223, value: 0.5820633950},
{tk: 38333, value: 0.5820633950},
{tk: 38334, value: 0.5572380100},
{tk: 38445, value: 0.5820633950},
{tk: 38446, value: 0.5820633950},
{tk: 38500, value: 0.7955793219},
{tk: 38511, value: 0.5820633950},
{tk: 40003, value: 0.7863404622},
{tk: 40006, value: 0.7883890185},
{tk: 40007, value: 0.849480998},
{tk: 40100, value: 0.7945757294},
{tk: 40200, value: 0.9657163481},
{tk: 40300, value: 0.7240819116},
{tk: 40400, value: 0.7284961613},
{tk: 41000, value: 0.7185759140},
{tk: 41001, value: 0.7185759140},
{tk: 41002, value: 0.7185759140},
{tk: 41004, value: 0.7185759140},
{tk: 41005, value: 0.7106457520},
{tk: 41110, value: 0.7185759140},
{tk: 41221, value: 0.7185759140},
{tk: 41222, value: 0.7185759140},
{tk: 41223, value: 0.7185759140},
{tk: 41234, value: 0.7185759140},
{tk: 41236, value: 0.7185759140},
{tk: 41334, value: 0.7185759140},
{tk: 41335, value: 0.7185759140},
{tk: 41336, value: 0.7185759140},
{tk: 41435, value: 0.7185759140},
{tk: 41447, value: 0.7185759140},
{tk: 41448, value: 0.7185759140},
{tk: 41500, value: 0.7167159161},
{tk: 42031, value: 0.7368224992},
{tk: 42032, value: 1.0806086435},
{tk: 42100, value: 0.6734085420},
{tk: 42101, value: 0.6734085420},
{tk: 42110, value: 0.6734085420},
{tk: 42131, value: 0.6734085420},
{tk: 42132, value: 0.6734085420},
{tk: 42150, value: 0.7510333374},
{tk: 42200, value: 1.0385416461},
{tk: 43060, value: 0.9520046935},
{tk: 43061, value: 0.6447778621},
{tk: 43063, value: 0.9241541496},
{tk: 43100, value: 0.6508570010},
{tk: 43101, value: 0.6508570010},
{tk: 43110, value: 0.6508570010},
{tk: 43131, value: 0.6508570010},
{tk: 43132, value: 0.6508570010},
{tk: 43150, value: 0.9169257501},
{tk: 43200, value: 0.6646089305},
{tk: 43300, value: 0.6684067565},
{tk: 44001, value: 1.0017857682},
{tk: 44002, value: 0.9451103853},
{tk: 44003, value: 0.7876127939},
{tk: 44010, value: 1.1727793376},
{tk: 44100, value: 1.0957861962},
{tk: 44200, value: 1.0741653724},
{tk: 45000, value: 0.8417770720},
{tk: 45001, value: 0.8417770720},
{tk: 45002, value: 0.8417770720},
{tk: 45003, value: 0.8417770720},
{tk: 45004, value: 0.8417770720},
{tk: 45005, value: 0.8417770720},
{tk: 45110, value: 0.8417770720},
{tk: 45221, value: 0.8417770720},
{tk: 45222, value: 0.8408011880},
{tk: 45332, value: 0.8417770720},
{tk: 45333, value: 0.8417770720},
{tk: 45444, value: 0.8417770720},
{tk: 45445, value: 0.8492853460},
{tk: 45500, value: 0.9087298590},
{tk: 45510, value: 0.8417770720},
{tk: 45511, value: 0.8417770720},
{tk: 45512, value: 0.8417770720},
{tk: 45513, value: 0.8417770720},
{tk: 45514, value: 0.8417770720},
{tk: 45515, value: 0.8417770720},
{tk: 45516, value: 0.8417770720},
{tk: 45517, value: 0.8417770720},
{tk: 45518, value: 0.8417770720},
{tk: 45519, value: 0.8417770720},
{tk: 45550, value: 0.8350239390},
{tk: 45560, value: 0.8395292830},
{tk: 45570, value: 0.8524441870},
{tk: 45580, value: 0.8528291150},
{tk: 46030, value: 0.5460673475},
{tk: 46100, value: 0.5558072297},
{tk: 46200, value: 0.6825829119},
{tk: 46300, value: 0.7139044213},
{tk: 47040, value: 0.5941461415},
{tk: 47041, value: 0.4252333580},
{tk: 47043, value: 0.8598450298},
{tk: 47044, value: 0.8367899824},
{tk: 47045, value: 0.8801847461},
{tk: 47100, value: 0.5076462470},
{tk: 47101, value: 0.5076462470},
{tk: 47110, value: 0.5076462470},
{tk: 47131, value: 0.5076462470},
{tk: 47132, value: 0.5076462470},
{tk: 47150, value: 0.5933088351},
{tk: 48060, value: 0.5051193304},
{tk: 48061, value: 0.6726034206},
{tk: 48062, value: 0.5313894305},
{tk: 48100, value: 0.4490522158},
{tk: 48200, value: 0.6896306294},
{tk: 48300, value: 0.7858531524},
{tk: 49080, value: 0.3949665028},
{tk: 49081, value: 0.5452033554},
{tk: 49082, value: 0.3705679344},
{tk: 49083, value: 0.5484165802},
{tk: 49084, value: 0.4793360886},
{tk: 49100, value: 0.4251203410},
{tk: 49101, value: 0.4251203410},
{tk: 49110, value: 0.4251203410},
{tk: 49131, value: 0.4251203410},
{tk: 49132, value: 0.4251203410},
{tk: 49150, value: 0.4608364332},
{tk: 50001, value: 1.0427227218},
{tk: 50002, value: 1.1509866837},
{tk: 50007, value: 1.2485698108},
{tk: 50010, value: 0.9284099873},
{tk: 50100, value: 1.1172488060},
{tk: 50101, value: 1.1172488060},
{tk: 50110, value: 1.1172488060},
{tk: 50131, value: 1.1172488060},
{tk: 50132, value: 1.1172488060},
{tk: 50150, value: 1.1076588976},
{tk: 50200, value: 1.0742573153},
{tk: 50300, value: 1.1188702341},
{tk: 50400, value: 1.0592748752},
{tk: 50500, value: 0.9813382330},
{tk: 51030, value: 1.0289138880},
{tk: 51100, value: 1.1136840864},
{tk: 51200, value: 1.0072727383},
{tk: 52050, value: 1.1919599865},
{tk: 52051, value: 1.3004753022},
{tk: 52052, value: 1.1634645491},
{tk: 52055, value: 1.2570732709},
{tk: 52056, value: 1.0298990480},
{tk: 52057, value: 1.0288218403},
{tk: 52100, value: 1.1609264928},
{tk: 52200, value: 1.1513296573},
{tk: 53070, value: 1.0492992710},
{tk: 53071, value: 1.1101319592},
{tk: 53073, value: 1.2156790068},
{tk: 53077, value: 1.2070020365},
{tk: 53100, value: 1.1941040154},
{tk: 53200, value: 1.0544620542},
{tk: 53533, value: 0.7695274520},
{tk: 54000, value: 0.7120931670},
{tk: 54001, value: 0.7120931670},
{tk: 54002, value: 0.7120931670},
{tk: 54003, value: 0.7120931670},
{tk: 54004, value: 0.7120931670},
{tk: 54005, value: 0.7120931670},
{tk: 54006, value: 0.7120931670},
{tk: 54007, value: 0.7120931670},
{tk: 54008, value: 0.7120931670},
{tk: 54009, value: 0.7120931670},
{tk: 54010, value: 0.7120931670},
{tk: 54011, value: 0.7120931670},
{tk: 54012, value: 0.7120931670},
{tk: 54013, value: 0.7120931670},
{tk: 54014, value: 0.7120931670},
{tk: 54015, value: 0.7120931670},
{tk: 54016, value: 0.7120931670},
{tk: 54101, value: 0.7120931670},
{tk: 54110, value: 0.7120931670},
{tk: 54121, value: 0.7120931670},
{tk: 54122, value: 0.7120931670},
{tk: 54123, value: 0.7120931670},
{tk: 54124, value: 0.7120931670},
{tk: 54201, value: 0.7120931670},
{tk: 54210, value: 0.7120931670},
{tk: 54247, value: 0.7120931670},
{tk: 54248, value: 0.7120931670},
{tk: 54249, value: 0.7120931670},
{tk: 54250, value: 0.7120931670},
{tk: 54252, value: 0.7120931670},
{tk: 54301, value: 0.7120931670},
{tk: 54310, value: 0.7120931670},
{tk: 54340, value: 0.7233337400},
{tk: 54351, value: 0.7257778590},
{tk: 54352, value: 0.7120931670},
{tk: 54359, value: 0.7233337400},
{tk: 54401, value: 0.7120931670},
{tk: 54410, value: 0.7120931670},
{tk: 54453, value: 0.7120931670},
{tk: 54454, value: 0.7120931670},
{tk: 54500, value: 0.8238279283},
{tk: 54517, value: 0.7970793320},
{tk: 54621, value: 0.7120931670},
{tk: 54622, value: 0.7120931670},
{tk: 54623, value: 0.7120931670},
{tk: 54624, value: 0.7120931670},
{tk: 54625, value: 0.7120931670},
{tk: 54626, value: 0.7120931670},
{tk: 54627, value: 0.7120931670},
{tk: 54628, value: 0.7198480900},
{tk: 54629, value: 0.7204613580},
{tk: 54630, value: 0.7120931670},
{tk: 54631, value: 0.7120931670},
{tk: 54632, value: 0.7395767550},
{tk: 54633, value: 0.7120931670},
{tk: 54634, value: 0.7120931670},
{tk: 54635, value: 0.7120931670},
{tk: 54636, value: 0.7120931670},
{tk: 54637, value: 0.7120931670},
{tk: 54638, value: 0.7120931670},
{tk: 54639, value: 0.7120931670},
{tk: 54640, value: 0.7120931670},
{tk: 54641, value: 0.7120931670},
{tk: 54642, value: 0.7120931670},
{tk: 54643, value: 0.7120931670},
{tk: 54644, value: 0.7120931670},
{tk: 54645, value: 0.7120931670},
{tk: 54646, value: 0.7120931670},
{tk: 54655, value: 0.7120931670},
{tk: 54660, value: 0.7198480900},
{tk: 55100, value: 0.6761102970},
{tk: 55101, value: 0.6761102970},
{tk: 55102, value: 0.6761102970},
{tk: 55104, value: 0.6761102970},
{tk: 55110, value: 0.6761102970},
{tk: 55131, value: 0.6761102970},
{tk: 55132, value: 0.6761102970},
{tk: 55133, value: 0.6761102970},
{tk: 55134, value: 0.6761102970},
{tk: 55135, value: 0.6761102970},
{tk: 55200, value: 0.8650236680},
{tk: 55201, value: 0.8650236680},
{tk: 55210, value: 0.8650236680},
{tk: 55236, value: 0.8650236680},
{tk: 55400, value: 0.7520643450},
{tk: 55401, value: 0.7520643450},
{tk: 55410, value: 0.7520643450},
{tk: 55437, value: 0.7520643450},
{tk: 55438, value: 0.7520643450},
{tk: 55500, value: 0.7233337400},
{tk: 55501, value: 0.7233337400},
{tk: 55510, value: 0.7233337400},
{tk: 55534, value: 0.7233337400},
{tk: 55535, value: 0.7233337400},
{tk: 55536, value: 0.7233337400},
{tk: 56000, value: 0.7470576990},
{tk: 56001, value: 0.8756315100},
{tk: 56102, value: 0.7198480900},
{tk: 56122, value: 0.7198480900},
{tk: 56200, value: 0.7379100880},
{tk: 56201, value: 0.7379100880},
{tk: 56210, value: 0.7379100880},
{tk: 56224, value: 0.7379100880},
{tk: 56225, value: 0.7379100880},
{tk: 56226, value: 0.7379100880},
{tk: 56231, value: 0.7379100880},
{tk: 56238, value: 0.7379100880},
{tk: 56300, value: 0.7198480900},
{tk: 56301, value: 0.7198480900},
{tk: 56310, value: 0.7198480900},
{tk: 56333, value: 0.7695274520},
{tk: 56334, value: 0.7331652830},
{tk: 56335, value: 0.7695274520},
{tk: 56400, value: 0.7470576990},
{tk: 56401, value: 0.7470576990},
{tk: 56404, value: 0.7470576990},
{tk: 56410, value: 0.7470576990},
{tk: 56424, value: 0.7379100880},
{tk: 56425, value: 0.7379100880},
{tk: 56428, value: 0.7198480900},
{tk: 56429, value: 0.8095181275},
{tk: 56430, value: 0.7470576990},
{tk: 56431, value: 0.7470576990},
{tk: 56435, value: 0.7470576990},
{tk: 56436, value: 0.7470576990},
{tk: 56437, value: 0.7470576990},
{tk: 56438, value: 0.7379100880},
{tk: 56439, value: 0.7198480900},
{tk: 56448, value: 0.7695274520},
{tk: 56449, value: 0.7695274520},
{tk: 56450, value: 0.7379100880},
{tk: 56500, value: 0.7695274520},
{tk: 56501, value: 0.7695274520},
{tk: 56510, value: 0.7695274520},
{tk: 56532, value: 0.7695274520},
{tk: 56533, value: 0.7695274520},
{tk: 56535, value: 0.7695274520},
{tk: 56550, value: 0.7695274520},
{tk: 56600, value: 0.7379100880},
{tk: 56601, value: 0.7379100880},
{tk: 56610, value: 0.7379100880},
{tk: 56622, value: 0.7379100880},
{tk: 56625, value: 0.7564734560},
{tk: 56626, value: 0.7379100880},
{tk: 57000, value: 0.7517703720},
{tk: 57001, value: 0.7309334990},
{tk: 57002, value: 1.0230820252},
{tk: 57003, value: 0.7649384220},
{tk: 57004, value: 0.6571461090},
{tk: 57006, value: 0.8882294154},
{tk: 57007, value: 0.7570562318},
{tk: 57008, value: 0.7462536960},
{tk: 57009, value: 0.7223762685},
{tk: 57010, value: 0.9620184440},
{tk: 57011, value: 0.8018966127},
{tk: 57012, value: 0.8825684449},
{tk: 57013, value: 0.8220970492},
{tk: 57014, value: 0.8006620341},
{tk: 57019, value: 0.6780920410},
{tk: 57021, value: 0.9019055006},
{tk: 57023, value: 0.7504594590},
{tk: 57100, value: 0.8127672756},
{tk: 57200, value: 0.9675006055},
{tk: 57300, value: 0.7479673935},
{tk: 57400, value: 0.7504594590},
{tk: 57500, value: 0.7816157618},
{tk: 58002, value: 1.1745835538},
{tk: 58005, value: 0.7682152980},
{tk: 58100, value: 0.8211981467},
{tk: 58200, value: 1.0441618268},
{tk: 58300, value: 0.7585177275},
{tk: 58400, value: 0.9525089451},
{tk: 58500, value: 0.8037368524},
{tk: 59031, value: 0.7913290914},
{tk: 59035, value: 0.8682593225},
{tk: 59100, value: 0.8697929550},
{tk: 59101, value: 0.8697929550},
{tk: 59110, value: 0.8697929550},
{tk: 59131, value: 0.8697929550},
{tk: 59132, value: 0.8697929550},
{tk: 59150, value: 0.9340606911},
{tk: 59200, value: 1.0497350547},
{tk: 59300, value: 0.7494616215},
{tk: 60063, value: 0.8610570949},
{tk: 60065, value: 0.7728799778},
{tk: 60100, value: 0.7662214490},
{tk: 60101, value: 0.7662214490},
{tk: 60110, value: 0.7662214490},
{tk: 60131, value: 0.7662214490},
{tk: 60132, value: 0.7662214490},
{tk: 60133, value: 0.7662214490},
{tk: 60134, value: 0.7662214490},
{tk: 60150, value: 0.8918132657},
{tk: 60200, value: 0.9909652035},
{tk: 60300, value: 0.8006172010},
{tk: 60434, value: 0.7662214490},
{tk: 61007, value: 0.8235068768},
{tk: 61100, value: 0.8976698119},
{tk: 61200, value: 0.8748637797},
{tk: 61300, value: 1.0416980744},
{tk: 61500, value: 0.9108299420},
{tk: 61600, value: 0.9108299420},
{tk: 61700, value: 0.9108299420},
{tk: 62041, value: 0.7896275257},
{tk: 62042, value: 0.8989613399},
{tk: 62047, value: 0.8824814258},
{tk: 62055, value: 0.9026692235},
{tk: 62100, value: 0.7978856070},
{tk: 62101, value: 0.7978856070},
{tk: 62110, value: 0.7978856070},
{tk: 62121, value: 0.7978856070},
{tk: 62122, value: 0.8077255250},
{tk: 62123, value: 0.7978856070},
{tk: 62124, value: 0.7978856070},
{tk: 62125, value: 0.7978856070},
{tk: 62200, value: 0.8283834594},
{tk: 62222, value: 0.7978856070},
{tk: 62300, value: 0.8583193082},
{tk: 62400, value: 0.8235408258},
{tk: 62500, value: 0.8651536346},
{tk: 63072, value: 0.6691874999},
{tk: 63073, value: 0.9588372125},
{tk: 63074, value: 0.9429880496},
{tk: 63075, value: 0.6812409432},
{tk: 63077, value: 0.6775983311},
{tk: 63078, value: 0.6951626139},
{tk: 63080, value: 0.7705735440},
{tk: 63081, value: 0.6414253540},
{tk: 63085, value: 0.6573962403},
{tk: 63086, value: 0.7153687290},
{tk: 63087, value: 0.6498572562},
{tk: 63088, value: 0.6863494193},
{tk: 63100, value: 0.9476973334},
{tk: 63200, value: 0.7185395442},
{tk: 64002, value: 0.7460837070},
{tk: 64003, value: 0.9615017573},
{tk: 64004, value: 0.7218120117},
{tk: 64006, value: 0.7793808155},
{tk: 64007, value: 0.7879340070},
{tk: 64008, value: 0.8452417896},
{tk: 64009, value: 1.2001187813},
{tk: 64010, value: 0.7469420892},
{tk: 64100, value: 0.9320779158},
{tk: 64200, value: 0.8689677476},
{tk: 65000, value: 0.7648185900},
{tk: 65001, value: 0.7648185900},
{tk: 65110, value: 0.7648185900},
{tk: 65201, value: 0.7648185900},
{tk: 65302, value: 0.7648185900},
{tk: 65303, value: 0.7648185900},
{tk: 65403, value: 0.7648185900},
{tk: 65404, value: 0.7648185900},
{tk: 65500, value: 0.7683233506},
{tk: 66031, value: 0.8007821026},
{tk: 66033, value: 1.2597229678},
{tk: 66035, value: 0.9504836933},
{tk: 66100, value: 0.8380582680},
{tk: 66101, value: 0.8380582680},
{tk: 66110, value: 0.8380582680},
{tk: 66131, value: 0.8380582680},
{tk: 66132, value: 0.8380582680},
{tk: 66133, value: 0.8380582680},
{tk: 66150, value: 0.9626346086},
{tk: 66200, value: 0.9932663563},
{tk: 66300, value: 0.8501820569},
{tk: 67062, value: 1.0515665351},
{tk: 67064, value: 0.8210507956},
{tk: 67100, value: 0.8180064560},
{tk: 67101, value: 0.8180064560},
{tk: 67110, value: 0.8180064560},
{tk: 67131, value: 0.8463485380},
{tk: 67132, value: 0.8180064560},
{tk: 67133, value: 0.8180064560},
{tk: 67150, value: 0.9976551478},
{tk: 67200, value: 0.8489407462},
{tk: 67300, value: 1.1401611886},
{tk: 68002, value: 0.6544146321},
{tk: 68003, value: 0.9176397930},
{tk: 68004, value: 1.0110204399},
{tk: 68006, value: 0.8873792520},
{tk: 68007, value: 0.8969173300},
{tk: 68010, value: 0.8824391735},
{tk: 68110, value: 0.7909986030},
{tk: 68131, value: 0.7909986030},
{tk: 68132, value: 0.7909986030},
{tk: 68133, value: 0.7909986030},
{tk: 68150, value: 0.8337059642},
{tk: 68200, value: 0.9253250463},
{tk: 68300, value: 0.9131795736},
{tk: 68400, value: 0.9306337575},
{tk: 68500, value: 0.8754686182},
{tk: 69100, value: 0.8896761070},
{tk: 69101, value: 0.8896761070},
{tk: 69110, value: 0.8896761070},
{tk: 69131, value: 0.8896761070},
{tk: 69132, value: 0.8896761070},
{tk: 69133, value: 0.8896761070},
{tk: 69150, value: 0.9082382597},
{tk: 69200, value: 0.9194129623},
{tk: 69300, value: 0.8882146199},
{tk: 69400, value: 0.7761772476},
{tk: 70003, value: 0.4995522411},
{tk: 70004, value: 0.3489909397},
{tk: 70006, value: 0.4263294030},
{tk: 70007, value: 0.4016591488},
{tk: 70008, value: 0.3669861104},
{tk: 70010, value: 0.4131672960},
{tk: 70013, value: 0.5115517704},
{tk: 70014, value: 0.2613144171},
{tk: 70016, value: 0.4222441022},
{tk: 70100, value: 0.4300293948},
{tk: 70200, value: 0.2878126618},
{tk: 70300, value: 0.4307867748},
{tk: 70400, value: 0.3483206469},
{tk: 71000, value: 0.2319748600},
{tk: 71001, value: 0.2319748600},
{tk: 71004, value: 0.2319748600},
{tk: 71006, value: 0.2319748600},
{tk: 71110, value: 0.2319748600},
{tk: 71201, value: 0.2319748600},
{tk: 71202, value: 0.2319748600},
{tk: 71301, value: 0.2319748600},
{tk: 71303, value: 0.2319748600},
{tk: 71304, value: 0.2319748600},
{tk: 71305, value: 0.2319748600},
{tk: 71306, value: 0.2319748600},
{tk: 71307, value: 0.2319748600},
{tk: 71408, value: 0.2223664685},
{tk: 71409, value: 0.2319748600},
{tk: 71410, value: 0.2319748600},
{tk: 71414, value: 0.2864199830},
{tk: 71500, value: 0.3381772028},
{tk: 72052, value: 0.6935303792},
{tk: 72053, value: 0.3175239038},
{tk: 72055, value: 0.3794437388},
{tk: 72100, value: 0.2641849010},
{tk: 72102, value: 0.2406156240},
{tk: 72150, value: 0.4003814866},
{tk: 72200, value: 0.3923943073},
{tk: 72300, value: 0.3711459817},
{tk: 72400, value: 0.4494613046},
{tk: 73001, value: 0.3901630919},
{tk: 73002, value: 0.3927082705},
{tk: 73003, value: 0.3823087767},
{tk: 73004, value: 0.4853990410},
{tk: 73005, value: 0.4043967944},
{tk: 73006, value: 0.3292190647},
{tk: 73007, value: 0.3707660472},
{tk: 73011, value: 0.3784055293},
{tk: 73014, value: 0.2708462943},
{tk: 73100, value: 0.2296510480},
{tk: 73101, value: 0.2296510480},
{tk: 73102, value: 0.2296510480},
{tk: 73103, value: 0.2296510480},
{tk: 73110, value: 0.2296510480},
{tk: 73131, value: 0.2296510480},
{tk: 73132, value: 0.2296510480},
{tk: 73133, value: 0.2296510480},
{tk: 73134, value: 0.2296510480},
{tk: 73135, value: 0.2296510480},
{tk: 73136, value: 0.2296510480},
{tk: 73137, value: 0.2296510480},
{tk: 73200, value: 0.2938494486},
{tk: 73232, value: 0.2296510480},
{tk: 73233, value: 0.2296510480},
{tk: 73300, value: 0.3277783597},
{tk: 73400, value: 0.3389085704},
{tk: 73500, value: 0.3430359663},
{tk: 74051, value: 0.5368446260},
{tk: 74052, value: 0.3366418275},
{tk: 74053, value: 0.3488914573},
{tk: 74055, value: 0.4174281635},
{tk: 74061, value: 0.4479717788},
{tk: 74100, value: 0.1866417610},
{tk: 74101, value: 0.1866417610},
{tk: 74102, value: 0.1866417610},
{tk: 74110, value: 0.1866417610},
{tk: 74131, value: 0.1866417610},
{tk: 74132, value: 0.1866417610},
{tk: 74133, value: 0.1866417610},
{tk: 74150, value: 0.3315032361},
{tk: 80100, value: 0.4042881441},
{tk: 81100, value: 0.4853074820},
{tk: 81101, value: 0.6384286631},
{tk: 81102, value: 0.5676926590},
{tk: 81103, value: 0.5697928233},
{tk: 81104, value: 0.5666111468},
{tk: 81105, value: 0.5029830312},
{tk: 81106, value: 0.5455648514},
{tk: 81107, value: 0.5856432003},
{tk: 81108, value: 0.6294417928},
{tk: 81109, value: 0.5837845256},
{tk: 81131, value: 0.4853074820},
{tk: 81132, value: 0.4853074820},
{tk: 81150, value: 0.5381929400},
{tk: 81200, value: 0.6109256247},
{tk: 81300, value: 0.5031153493},
{tk: 81400, value: 0.6072959216},
{tk: 81401, value: 0.6076110813},
{tk: 81500, value: 0.4863949133},
{tk: 82100, value: 0.4380138820},
{tk: 82101, value: 0.3496597121},
{tk: 82102, value: 0.4298261742},
{tk: 82103, value: 0.4703311496},
{tk: 82104, value: 0.3837052748},
{tk: 82110, value: 0.4380138820},
{tk: 82131, value: 0.4380138820},
{tk: 82132, value: 0.4006463795},
{tk: 82150, value: 0.5140786500},
{tk: 82300, value: 0.5189684967},
{tk: 83100, value: 0.3778297611},
{tk: 83103, value: 0.4163651344},
{tk: 83104, value: 0.4215890656},
{tk: 83200, value: 0.4297187321},
{tk: 83300, value: 0.4283587920},
{tk: 83301, value: 0.4668216746},
{tk: 83302, value: 0.4446305714},
{tk: 83400, value: 0.2701082896},
{tk: 84001, value: 0.2627006361},
{tk: 84002, value: 0.3987770525},
{tk: 84003, value: 0.2914503115},
{tk: 84004, value: 0.2409019502},
{tk: 84005, value: 0.3077489946},
{tk: 84006, value: 0.2814817192},
{tk: 84007, value: 0.2467147007},
{tk: 84008, value: 0.2603544816},
{tk: 84009, value: 0.2231143187},
{tk: 84010, value: 0.2385168383},
{tk: 84011, value: 0.2642299761},
{tk: 84100, value: 0.3002906530},
{tk: 84200, value: 0.4122737909},
{tk: 84300, value: 0.2792382723},
{tk: 84302, value: 0.4339536154},
{tk: 84400, value: 0.3221117908},
{tk: 84401, value: 0.2699132767},
{tk: 84500, value: 0.4981701233},
{tk: 84501, value: 0.4053674443},
{tk: 84600, value: 0.2719057355},
{tk: 84700, value: 0.2637626019},
{tk: 84702, value: 0.2369474583},
{tk: 84703, value: 0.2257112420},
{tk: 84800, value: 0.2697988090},
{tk: 85001, value: 0.2285321479},
{tk: 85002, value: 0.1927496788},
{tk: 85003, value: 0.2476153736},
{tk: 85100, value: 0.1710551110},
{tk: 85101, value: 0.2632985848},
{tk: 85102, value: 0.2676828745},
{tk: 85103, value: 0.2419627890},
{tk: 85104, value: 0.3745955031},
{tk: 85105, value: 0.2764513650},
{tk: 85107, value: 0.1933715225},
{tk: 85108, value: 0.3049253629},
{tk: 85109, value: 0.2807768205},
{tk: 85110, value: 0.1412527176},
{tk: 85111, value: 0.1598609651},
{tk: 85112, value: 0.1710551110},
{tk: 85131, value: 0.1710551110},
{tk: 85132, value: 0.1710551110},
{tk: 85133, value: 0.2133741420},
{tk: 85150, value: 0.2293826090},
{tk: 85200, value: 0.2492424665},
{tk: 85300, value: 0.3067347700},
{tk: 85301, value: 0.2091386710},
{tk: 85302, value: 0.2615967985},
{tk: 85303, value: 0.2259667544},
{tk: 85304, value: 0.2301944310},
{tk: 85400, value: 0.2357994109},
{tk: 85401, value: 0.2219656370},
{tk: 85500, value: 0.2393954051},
{tk: 85600, value: 0.2206671923},
{tk: 85700, value: 0.2761605305},
{tk: 85800, value: 0.1657194985},
{tk: 85900, value: 0.2145538601}
]